/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/KubernetesEndpoint/Actions/AzureSubscriptionAuthActions" />
import { IKubernetesCluster } from "DistributedTask/Common/AzureResourcesService/AzureResourceContracts";
import { ActionsHubBase, Action } from "DistributedTask/Flux/Actions";
import { AzureSubscriptionAuthKeys } from "DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/KubernetesEndpoint/KubernetesEndpointConstants";

export class AzureSubscriptionAuthActions extends ActionsHubBase {
    public static getKey(): string {
        return AzureSubscriptionAuthKeys.ActionsKey;
    }

    public initialize(instanceId?: string): void {
        this._updateAksClusterList = new Action<IKubernetesCluster[]>();
        this._updateAksClusterNamespaceList = new Action<string[]>();
        this._resetAksClusterList = new Action<void>();
        this._resetAksClusterNamespaceList = new Action<void>();
        this._updateErrorMessage = new Action<string>();
        this._setAccessToken = new Action<string>();
        this._fetchingMoreClusters = new Action<boolean>();
        this._fetchingMoreNamespaces = new Action<boolean>();
    }

    public get setAccessToken(): Action<string> {
        return this._setAccessToken;
    }

    public get updateAksClusterList(): Action<IKubernetesCluster[]> {
        return this._updateAksClusterList;
    }

    public get resetAksClusterList(): Action<void> {
        return this._resetAksClusterList;
    }

    public get fetchingMoreClusters(): Action<boolean> {
        return this._fetchingMoreClusters;
    }

    public get fetchingMoreNamespaces(): Action<boolean> {
        return this._fetchingMoreNamespaces;
    }

    public get updateAksClusterNamespaceList(): Action<string[]> {
        return this._updateAksClusterNamespaceList;
    }

    public get resetAksClusterNamespaceList(): Action<void> {
        return this._resetAksClusterNamespaceList;
    }

    public get updateErrorMessage(): Action<string> {
        return this._updateErrorMessage;
    }

    private _updateAksClusterList: Action<IKubernetesCluster[]>;
    private _updateAksClusterNamespaceList: Action<string[]>;
    private _resetAksClusterList: Action<void>;
    private _resetAksClusterNamespaceList: Action<void>;
    private _updateErrorMessage: Action<string>;
    private _setAccessToken: Action<string>;
    private _fetchingMoreClusters: Action<boolean>;
    private _fetchingMoreNamespaces: Action<boolean>;
}
